import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
export var SearchRequest =
/*#__PURE__*/
function () {
  function SearchRequest(transport, query, searchkit) {
    _classCallCheck(this, SearchRequest);

    this.transport = transport;
    this.query = query;
    this.searchkit = searchkit;
    this.active = true;
  }

  _createClass(SearchRequest, [{
    key: "run",
    value: function run() {
      return this.transport.search(this.query).then(this.setResults.bind(this)).catch(this.setError.bind(this));
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      this.active = false;
    }
  }, {
    key: "setResults",
    value: function setResults(results) {
      if (this.active) {
        this.searchkit.setResults(results);
      }
    }
  }, {
    key: "setError",
    value: function setError(error) {
      if (this.active) {
        this.searchkit.setError(error);
      }
    }
  }]);

  return SearchRequest;
}();